import { Mark, mergeAttributes } from '@tiptap/core'

export interface VariableHighlightOptions {
  HTMLAttributes: Record<string, any>
}

export const VariableHighlight = Mark.create<VariableHighlightOptions>({
  name: 'variableHighlight',

  addOptions() {
    return {
      HTMLAttributes: {},
    }
  },

  parseHTML() {
    return [
      {
        tag: 'span[data-variable]',
      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'span',
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
        'data-variable': '',
        style:
          'color: #C87FFF; background-color: rgba(200, 127, 255, 0.1); padding: 1px 2px; border-radius: 2px;',
      }),
      0,
    ]
  },
})
